import { ApiProperty } from '@nestjs/swagger';
import { IsArray, IsUUID } from 'class-validator';

export class AsignarEquipoDto {
  @ApiProperty({ type: [String], description: 'IDs de vendedores/cobradores a asignar' })
  @IsArray()
  @IsUUID('all', { each: true })
  vendedor_cobrador_ids: string[];
}
